<template>
<section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
            <el-form-item>
                <el-date-picker v-model="filters.flowmonth" type="month" :clearable="false" :editable="false" placeholder="查询月份">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-input v-model="filters.msisdn" placeholder="输卡号/ICCID/IMSI/查询码"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" v-on:click="getFlowInfoList">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" v-on:click="exportData()">导出EXCEL</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="flowInfo" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
        <el-table-column prop="msisdn" label="卡号" width="200" sortable>
        </el-table-column>
        <el-table-column prop="iccid" label="ICCID" width="200" sortable>
        </el-table-column>
        <el-table-column prop="imsi" label="IMSI" width="200" sortable>
        </el-table-column>
        <el-table-column prop="flowmonth" label="所属月份" width="200" sortable>
        </el-table-column>
        <el-table-column prop="querycode" label="查询代码" width="200" sortable>
        </el-table-column>
        <el-table-column prop="servicename" label="所属用户" width="180" sortable>
        </el-table-column>
        <el-table-column prop="apicode" label="所属API" width="180" sortable>
        </el-table-column>
        <el-table-column prop="gprsused" label="本月已用流量(MB)" width="200" sortable>
        </el-table-column>
        <el-table-column prop="flowthreshold" label="流量阀值(MB)" width="200" sortable>
        </el-table-column>
        <el-table-column prop="excessflow" label="超出流量值(MB)" width="200" sortable>
        </el-table-column>

        <el-table-column label="操作" width="80" fixed="right">
            <template scope="scope">
                <el-button size="small" @click="getflowDetails(scope.$index, scope.row)">详情</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog title="预警详情信息" :visible.sync="flowDetailVisible" :close-on-click-modal="false">
        <el-form label-width="100px" :model="flowDetail" ref="flowDetail">
            <div style="overflow: auto; width: 100%;">
                <table class="border-table">
                    <tr>
                        <td class="alt">卡号：</td>
                        <td>{{flowDetail.msisdn}}</td>
                        <td class="alt">ICCID:</td>
                        <td>{{flowDetail.iccid}}</td>

                    </tr>
                    <tr>
                        <td class="alt">IMSI:</td>
                        <td>{{flowDetail.imsi}}</td>
                        <td class="alt">查询代码：</td>
                        <td>{{flowDetail.querycode}}</td>

                    </tr>
                    <tr>
                        <td class="alt">所属用户:</td>
                        <td>{{flowDetail.servicename}}</td>
                        <td class="alt">所属API:</td>
                        <td>{{flowDetail.apicode}}</td>
                    </tr>
                    <tr>
                        <td class="alt">本月已用流量(MB)：</td>
                        <td>{{flowDetail.gprsused}}</td>
                        <td class="alt">流量阀值(MB):</td>
                        <td>{{flowDetail.flowthreshold}}</td>
                    </tr>
                    <tr>
                        <td class="alt">超出流量值(MB):</td>
                        <td>{{flowDetail.excessflow}}</td>
                    </tr>
                </table>
            </div>

        </el-form>
    </el-dialog>
    <!--工具条(分页)-->
    <el-col :span="24" class="toolbar">
        <!--

<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>

-->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
    </el-col>

</section>
</template>

<script>
import util from '../../common/js/util'
import constant from '../../common/js/constant'
//import NProgress from 'nprogress'
import {
    getFlowInfo,
    getFlowDetail
} from '../../api/api';
let todayDate = new Date();
let month = todayDate.getMonth() + 1;
let year = todayDate.getFullYear();
export default {
    data() {

        return {
            flowInfo: [],
            total: 0, //列表总条数
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            listLoading: false,
            flowDetailVisible: false,
            editLoading: false,
            filters: {
                msisdn: '',
                flowmonth: year + '-' + month,

            },
            flowDetail: {
                //超出ID
                flowid: '',
                //超出流量值
                excessflow: '',
                //月份
                flowmonth: '',
                //卡号
                msisdn: '',
                //卡识别码
                iccid: '',
                //用户识别码
                imsi: '',
                //所属服务商ID
                userid: '',
                //已用流量
                gprsused: '',
                //剩余流量
                gprsnow: '',
                //流量阀值
                flowthreshold: '',
                //API代码
                apicode: '',
                //服务商名字
                servicename: '',
                //查询编码
                querycode: ''

            }
        }
    },
    methods: {
        selsChange: function (sels) {
            this.sels = sels;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getFlowInfoList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getFlowInfoList();
        },
        //获取卡号列表
        getFlowInfoList() {
            let para = {
                pageSize: this.pageSize,
                pageNum: this.currentPage
            };
            para = Object.assign(para, this.filters);
            para.flowmonth = util.formatDate.format(new Date(para.flowmonth), 'yyyy-MM');
            this.listLoading = true;
            getFlowInfo(para).then((res) => {

                this.total = res.data.total;
                this.flowInfo = res.data.list;
                this.listLoading = false;
            });
        },
        getflowDetails: function (index, row) {
            let para = {
                flowid: row.flowid
            };
            getFlowDetail(para).then((res) => {
                this.flowDetailVisible = true;
                let {
                    msg,
                    code
                } = res;
                if (code !== 0) {
                    this.$message({
                        message: msg,
                        type: 'error'
                    });
                } else {
                    this.flowDetail = res.data;
                }
            });
        },
        exportData() {
            debugger;
            var flowmonths = util.formatDate.format(new Date(this.filters.flowmonth), 'yyyy-MM');
            var msisdns = this.filters.msisdn;
            location.href = "/api/excessflow/exportXls?flowmonth=" + flowmonths + "&msisdn=" + msisdns;
        }
    },
    mounted() {
        this.getFlowInfoList();

    }
}
</script>



// WEBPACK FOOTER //
// traffic_warning.vue?85b451b8